import { WidgetStrategyWithStreams } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { OpenSubmissionsCapsule } from './OpenSubmissionsCapsule';
import { getOpenSubmissionRequiredOrderColumns } from '../OpenSubmissionsStrategy';
import { openSubmissionsCapsuleWidgetStreamConfig } from './store/stream-config';
import { openSubmissionsTileDescription } from './description/openSubmissionsTileDescription';

export const openSubmissionsCapsuleWidgetStrategy: WidgetStrategyWithStreams = {
    title: 'Open Submissions',
    supportedHosts: ['tile'],
    reactComponentType: OpenSubmissionsCapsule,
    getRequiredOrderColumns: getOpenSubmissionRequiredOrderColumns,
    categories: [WidgetCategory.FILL_CAPSULES],
    description: openSubmissionsTileDescription,
    streamConfigs: [openSubmissionsCapsuleWidgetStreamConfig],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.PositionFromAtLeastOneOrder,
};
